import React from 'react';
import styles from "../styles.module.scss";
import Buklet from "../Icons/Buklet";
import OpenedMail from "../Icons/OpenedMail";
import Link from "next/link";
import PhoneCall from "../Icons/PhoneCall";


const Index = ({t, email, phone}) => {

  return (
    <div className={styles["contact-wrapper"]}>
      <div className={styles["contact"]}>
        <ul>
          <li>
            <div className={styles["icon"]}>
              <Buklet/>
            </div>
            <div className={styles["contact-content"]}>
              <p className={styles["content-header"]}>{t("form.office.header")}</p>
              <p dangerouslySetInnerHTML={{__html:t("form.office.text")}}></p>
            </div>
          </li>
          <li>
            <div className={styles["icon"]}>
              <OpenedMail/>
            </div>
            <div className={styles["contact-content"]}>
              <p className={styles["content-header"]}>{t("form.email.header")}</p>
              <p><Link href={`mailto:${email}`}>
                <a className={styles["form-link"]}>{email}</a>
              </Link></p>
            </div>
          </li>
          <li>
            <div className={styles["icon"]}>
              <PhoneCall/>
            </div>
            <div className={styles["contact-content"]}>
              <p className={styles["content-header"]}>{t("form.support.header")}</p>
              <p>
                <Link href={`tel:${phone.code}`}>
                  <a className={styles["footer-link"]}>{phone.pretty}</a>
                </Link>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Index;